export default "__VITE_ASSET__BXWLapBx__"